import React, { useEffect } from "react";
import { ProductDetailDto, ProductDetailRes, ProductRes } from "../../../types/productType";
import { Close } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { deleteWishList } from "../../../State/customer/WishlistSlice";
import { red } from "@mui/material/colors";
import { fetchProductById } from "../../../State/customer/ProductSlice";
import { colors } from "../../data/Filter/color";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import { AddItemRequest, addCartItemToCart } from "../../../State/customer/CartSlice";
export const WishListProductCard = ({
  item,
  id,
  handleAddToCart
}: {
  item: ProductDetailDto;
  id: number | null;
  handleAddToCart:(payload: AddItemRequest) => Promise<void>
}) => {
  const dispatch = useAppDispatch();
  const product = useAppSelector(
    (store) => store.product.entities[item.productId]
  );

  // find will return a single color
  const swatchHex =
    colors.find((c) => c.name.toLowerCase() === item.color.toLowerCase())
      ?.hex || item.color; // fallback if item.color is already a hex

  const handleRemoveWishList = async (productDetail: number) => {
    await dispatch(deleteWishList(productDetail)).unwrap();
  };
  const getProductByProductId = async (productId: number) => {
    await dispatch(fetchProductById(productId)).unwrap();
  };
  
  useEffect(() => {
    if (item.productId) {
      getProductByProductId(item.productId);
    }
  }, [item.productId, dispatch]);

  return (
    <div className="w-60 relative">
      <div style={{zIndex:1}} className="absolute top-0 right-0 ">
        {id != null && (
          <button >
            <Close
              onClick={() => {
                handleRemoveWishList(item.id);
              }}
              
              className="cursor-pointer bg-[#99AAAB] rounded-md p-1 "
              sx={{ color: red[400], fontSize: "2rem" }}
            />
          </button>
        )}
      </div>
      <Card sx={{ maxWidth: 345 }}>
       
          <CardMedia
            component="img"
            sx={{
              height: 200,        // cùng chiều cao cho tất cả
              width: "100%",
              objectFit: "cover", // cắt cho vừa khung, không méo
            }}  
            image={product?.images[0]}
            alt="not found"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {product?.title}
            </Typography>

            <div className="pt-3 space-y-1">
              <p>{product?.title}</p>
              <div className="flex items-center space-x-3">
                <p> {item.size} </p>
                <p
                  className="inline-block w-4 h-4 rounded-lg border-gray-600 border-2"
                  style={{ backgroundColor: swatchHex }}
                  aria-label={item.color}
                  title={item.color}
                />
              </div>
              <div className="price flex items-center gap-3">
                <span className="font-sans text-gray-800">
                  {item.sellingPrice}€
                </span>
                <span className="thin-line-through text-gray-400">
                  {product?.mrpPrice}€
                </span>
                <span className="text-primary font-semibold ">
                  {product?.discountPercentage}%
                </span>
              </div>
            </div>
          </CardContent>
          <CardActions style={{width:"80%",margin:"auto"}}>
        
        <Button onClick={() => { handleAddToCart({size:item.size,color:item.color,quantity:1,productId:item.productId}) }} className="" size="medium" variant="contained">Buy</Button>
        <Button onClick={() => {
                handleRemoveWishList(item.id);
              }} color="error" className="" size="medium" variant="contained">Remove</Button>
      </CardActions>
      </Card>
    </div>
  );
};
